import { Component, OnInit, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators} from '@angular/forms';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-nss',
  templateUrl: './nss.component.html',
  styleUrls: ['./nss.component.scss']
})
export class NssComponent implements OnInit {

  submitted = false;
  message = null;
  class = null;
  action = null;
  public Form: FormGroup;

  constructor(private formBuilder: FormBuilder, private http: HttpClient, private ActivatedRoute: ActivatedRoute, private router: Router, @Inject('API_ENDPOINT') private api_endpoint: string) { }

  ngOnInit() {
    this.Form = this.formBuilder.group({
      description: ['', Validators.required],
      _id: ['',],
      seohidden: ['']
    })

    this.http.get<any>(this.api_endpoint+'/nssfindone/').subscribe(
      data => {
        if(data.data != null){
          this.action = 'Update';
          this.Form.patchValue({
            description: data.data.description,
            _id: data.data._id,
            seohidden: data.data.seohidden
          })
        }else{
          this.action = 'Submit';
          this.Form.patchValue({
            description: '',
            _id: '',
          })
        }
    },
    (err: HttpErrorResponse) => {
      if (err.error instanceof Error) {
        console.log("Client-side error occured.");
      } else {
        console.log("Server-side error occured.");
      }
  });
  }

  get f() { return this.Form.controls; }

  onFormSubmit(action){
    // alert(action);
    console.log(this.Form.value);

    this.submitted = true;
    if(action == 'Update'){
      var data = {
        "description" : this.Form.value.description,
        "admin" : sessionStorage.getItem('adminName'),
        "_id" : this.Form.value._id,
        "seohidden" : this.Form.value.seohidden
      };
      this.http.put<any>(this.api_endpoint+'/nss', data).subscribe(
        res => {
          console.log(res);
          if(res.Error){
            this.message = res.Error;
            this.class = 'btn btn-primary';
            return
          }else{
            this.message = 'Successfully Updated';
            this.class = 'btn btn-success';
          } 
          window.scrollTo(document.documentElement.clientWidth, 0);
          window.location.reload();
      },
      (err: HttpErrorResponse) => {
        if (err.error instanceof Error) {
          console.log("Client-side error occured.");
        } else {
          console.log("Server-side error occured.");
        }
      });
    }else if(action == 'Submit'){
      // alert(this.Form.value.overview);
      var data1 = {
        "description" : this.Form.value.description,
        "admin" : sessionStorage.getItem('adminName'),
        "seohidden" : this.Form.value.seohidden
      };
      this.http.post<any>(this.api_endpoint+'/nss', data1).subscribe(
        res => {
          console.log(res);
          if(res.Error){
            this.message = res.Error;
            this.class = 'btn btn-primary';
            return
          }else{
            this.message = 'Successfully Added';
            this.class = 'btn btn-success';
          } 
          window.scrollTo(document.documentElement.clientWidth, 0);
          window.location.reload();
      },
      (err: HttpErrorResponse) => {
        if (err.error instanceof Error) {
          console.log("Client-side error occured.");
        } else {
          console.log("Server-side error occured.");
        }
      });
    }
  }

}
